import type { SchemaBuilderSelectCopyButtonProps } from "./schema-builder-select-copy-button.type";

import { CopyOutlined } from "@ant-design/icons";
import { Button, Form, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { useAppNotification } from "@/modules/app-notification";

export const SchemaBuilderSelectCopyButton = ({
  formListName,
  fieldKey,
}: SchemaBuilderSelectCopyButtonProps) => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();

  const form = Form.useFormInstance();
  const watchValues = Form.useWatch([formListName], form);

  const onCopyClick = () => {
    const value = watchValues[fieldKey].values.join(",");
    const title = t("schema:select.copy.message");
    navigator.clipboard.writeText(value);
    notify.info({ title, description: value });
  };

  return (
    <Tooltip title={t("schema:select.copy.tooltip")}>
      <Button type="text" icon={<CopyOutlined />} onClick={onCopyClick} />
    </Tooltip>
  );
};
